const CLOSED_LIFECYCLE_STATUSES = new Set(['expired', 'withdrawn']);

export const getOutstationLifecycleStatus = (gatepass) => {
  if (!gatepass) return 'pending';

  // Overdue gatepasses remain approved and active until the student enters.
  if (gatepass.utilizationStatus === 'overdue') return 'overdue';

  return gatepass.finalStatus || 'pending';
};

export const getApproverHistoryStatus = (gatepass, stage) => {
  const lifecycleStatus = getOutstationLifecycleStatus(gatepass);

  if (CLOSED_LIFECYCLE_STATUSES.has(lifecycleStatus) || lifecycleStatus === 'overdue') {
    return lifecycleStatus;
  }

  return gatepass?.stageStatus?.[stage]?.status
    || (lifecycleStatus === 'rejected' ? 'rejected' : 'pending');
};

export const getGatepassStatusLabel = (status, approvedLabel = 'APPROVED') => {
  switch (status) {
    case 'approved':
      return approvedLabel;
    case 'rejected':
    case 'denied':
      return 'REJECTED';
    case 'expired':
      return 'EXPIRED';
    case 'withdrawn':
      return 'WITHDRAWN';
    case 'overdue':
      return 'OVERDUE - ENTRY REQUIRED';
    case 'pending':
      return 'PENDING';
    default:
      return String(status || 'pending').replace(/_/g, ' ').toUpperCase();
  }
};

export const canDecideOutstationGatepass = (gatepass, stage) => (
  gatepass?.finalStatus === 'pending'
  && gatepass?.currentStage === stage
  && gatepass?.isActive !== false
);

export const isClosedOutstationGatepass = (gatepass) => (
  CLOSED_LIFECYCLE_STATUSES.has(getOutstationLifecycleStatus(gatepass))
  || gatepass?.finalStatus === 'rejected'
);
